import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LoggedOutPage' })(() => ({
  heading: {
    paddingBottom: 'var(--ebl-s3)',
  },
  main: {
    width: '100%',
    '& > *': {
      marginBottom: 'var(--ebl-s2) !important',
    },
  },
  returnBtn: {
    display: 'inline-block',
    margin: 'var(--ebl-s3) 0',
    textDecoration: 'none !important',
  },
}));
